import { render, staticRenderFns } from "./MinibusManagement.vue?vue&type=template&id=4d6fe0ce&scoped=true&"
import script from "./MinibusManagement.vue?vue&type=script&lang=js&"
export * from "./MinibusManagement.vue?vue&type=script&lang=js&"
import style0 from "./MinibusManagement.vue?vue&type=style&index=0&id=4d6fe0ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6fe0ce",
  null
  
)

export default component.exports